import React, { useState } from 'react';
import { PageHeader, Tabs, TabPanel } from '../ui';
import AttributesPanel from './AttributesPanel';
import FamiliesPanel from './FamiliesPanel';
import TemplateAdmin from './TemplateAdmin';
import './pim.css';

const TABS = [
  { id: 'template', label: 'Template' },
  { id: 'attributes', label: 'Attributes' },
  { id: 'families', label: 'Families' },
];

export default function SchemaAdmin() {
  const [active, setActive] = useState('template');
  return (
    <>
      <PageHeader
        title="Families & Attributes"
        sub="Define the configurable fields and product templates that drive the PIM."
      />
      <Tabs tabs={TABS} active={active} onChange={setActive} label="Schema sections" />
      <div style={{ marginTop: 16 }}>
        <TabPanel id="template" active={active}>
          <TemplateAdmin />
        </TabPanel>
        <TabPanel id="attributes" active={active}>
          <AttributesPanel />
        </TabPanel>
        <TabPanel id="families" active={active}>
          <FamiliesPanel />
        </TabPanel>
      </div>
    </>
  );
}
